module.exports = {"id":"200647","name":"Josip Iličić","rating":"81","photo":"./data/images/photos/3/200647.png","club":{"name":"Atalanta","logo":"./data/images/clubs/Atalanta.png"},"positions":["ATT","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JosipIlicic0.json
// module id = 2196
// module chunks = 0